export default "__VITE_PUBLIC_ASSET__84cd7316__"